import React, { useEffect, useRef, useState } from "react";

import Header3 from "../components/Header3";

import { ArrowLeft } from "react-bootstrap-icons"; // Assuming you're using Bootstrap Icons
import { Dropdown } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const messages = [
  {
    id: 1,
    name: "Sally Rooney",
    message: "Ok see you there!",
    timeAgo: "4 days ago",
    details: [
      {
        text: " user1 XXXXXXX XXXXXXXXXXXX XXXXX XXXXXXXX XXXXXX  XXXXXXXXXXXX XXXXXXX XXXXXXXXX XXXXXXXXXX   XXXXXXXX",
        time: "3:15",
      },
    ],
  },

  {
    id: 2,
    name: "Sally Rooney",
    message: "Ok see you there!",
    timeAgo: "4 days ago",
    details: [
      {
        text: "user2 XXXXXXX XXXXXXXXXXXX XXXXX XXXXXXXX XXXXXX  XXXXXXXXXXXX XXXXXXX XXXXXXXXX XXXXXXXXXX   XXXXXXXX",
        time: "3:15",
      },
    ],
  },

  {
    id: 3,
    name: "Sally Rooney",
    message: "Ok see you there!",
    timeAgo: "4 days ago",
    details: [
      {
        text: " User3 XXXXXXX XXXXXXXXXXXX XXXXX XXXXXXXX XXXXXX  XXXXXXXXXXXX XXXXXXX XXXXXXXXX XXXXXXXXXX   XXXXXXXX",
        time: "3:15",
      },
    ],
  },

  // Add more message objects as needed
];

const ChatBox2 = () => {
  const [selectedUser2, setSelectedUser2] = useState();
  const [isMobileDetailView, setIsMobileDetailView] = useState(false); // State to manage mobile view

  useEffect(() => {
    const savedUser2 = localStorage.getItem("selectedUser2");
    if (savedUser2) {
      setSelectedUser2(JSON.parse(savedUser2));
      setIsMobileDetailView(true); // Show detail view on refresh if a user is selected
    }
  }, []);

  const handleUserClick = (msg) => {
    setSelectedUser2(msg);
    setIsMobileDetailView(true); // Show details view for mobile
    localStorage.setItem("selectedUser2", JSON.stringify(msg)); // Save to localStorage
  };

  const handleGoBack = () => {
    setIsMobileDetailView(false); // Go back to the list view
    setSelectedUser2(null);
    localStorage.removeItem("selectedUser2"); // Clear localStorage
  };

  const [selectedOption, setSelectedOption] = useState("OPEN");

  useEffect(() => {
    const savedOption = localStorage.getItem("selectedOption");
    if (savedOption) {
      setSelectedOption(savedOption);
    }
  }, []);
  const navigate = useNavigate();

  const handleAccept = () => {
    if (selectedOption === "BOOKED") {
      const newOption = "BOOKED";
      setSelectedOption(newOption);
      localStorage.setItem("selectedOption", newOption); // Save state to localStorage
      toast.success("Your BOOKED Status is Accept  ");
      setTimeout(() => navigate("/chatbox", { replace: true }), 1);
    } else {
      toast.error("User Status is not BOOKED This Time.");
    }
  };

  const handleReject = () => {
    // setSelectedOption("OPEN"); // Reset the state to "OPEN"
    // localStorage.removeItem("selectedOption"); // Remove state from localStorage

    if (selectedOption === "BOOKED") {
      setSelectedOption("OPEN"); // Reset the state to "OPEN"
      localStorage.removeItem("selectedOption"); // Remove state from localStorage
      toast.success("Your Book Duo Status is Reject ");

      localStorage.removeItem("joinuserorgain");
      navigate("/meetorganizer", { replace: true });
    } else {
      toast.error("Status is already OPEN; no action needed.");
    }
  };

  const [message, setMessage] = useState("");
  const textareaRef = useRef(null);

  const handleInputChange = (e) => {
    setMessage(e.target.value);
    autoResize();
  };

  const autoResize = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "40px"; // Fixed initial height
    textarea.style.height = `${Math.min(textarea.scrollHeight, 150)}px`; // Expand up to 150px max
  };

  return (
    <>
      <div className="chatheder">
        <Header3 />
      </div>
      <div className="container bgcontrow scaloverallf mt-4">
        <div className="row bgcplorow ">
          <div className="d-flex justify-content-center  justify-content-lg-start mb-5  gap-xl-5 gap-lg-3">
            <div
              className=" wchatname d-lg-block d-none pb-1 rounded-1 w-100"
              style={{
                backgroundColor: "#D9D9D952",
                maxWidth: "376px",
                // height: "600px",
                height: "auto",
              }}
            >
              <div className="fw-bold pt-3 mx-3" style={{ fontSize: "30px" }}>
                Messages
              </div>

              <div>
                {messages?.map((msg) => (
                  <div
                    className={` list-group w-100 my-3 wchatname rounded-0 ${
                      selectedUser2 && selectedUser2.id === msg.id
                        ? "bg-highlight"
                        : ""
                    }`}
                    style={{
                      maxWidth: "377px",
                      height: "83px",
                      backgroundColor:
                        selectedUser2 && selectedUser2.id === msg.id
                          ? "#D0CECE"
                          : "transparent",
                    }}
                  >
                    <div
                      key={msg.id}
                      className={`list-group-item bg-transparent border-0 d-flex justify-content-between align-items-start"
                    selectedUser2 && selectedUser2.id === msg.id ? "bg-highlight" : ""
      }`}
                      onClick={() => handleUserClick(msg)} // Set selected user on click
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex gap-3">
                        <img
                          src={require("./image/paulsmithf.png")}
                          width="66"
                          height="66"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click event
                            navigate("/ambassadoruserprofile");
                          }}
                        />
                        <div>
                          <div className="fs-5 mt-2 fw-bold">{msg.name}</div>
                          <small>{msg.message}</small>
                        </div>
                      </div>
                      <small className="mt-4 fw600 ">{msg.timeAgo}</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              {!isMobileDetailView && (
                <div
                  className=" mobilwchatname bgcolorcli d-lg-none d-block rounded-1 w-100"
                  style={{
                    backgroundColor: "#D9D9D952",
                    maxWidth: "376px",
                    height: "590px",
                  }}
                >
                  <div
                    className="fw-bold pt-3 ftzwork mx-3"
                    style={{ fontSize: "30px" }}
                  >
                    Messages
                  </div>
                  {/* User List - Display on Mobile only if not in Detail View */}
                  <div className="list-group  my-3  rounded-0 ">
                    {messages?.map((msg) => (
                      <div
                        key={msg.id}
                        className="list-group-item bg-transparent mobilwchatnameagg border-0 d-flex justify-content-between align-items-start"
                        onClick={() => handleUserClick(msg)} // Set selected user on click
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex gap-3">
                          <img
                            src={require("./image/paulsmithf.png")}
                            width="66"
                            height="66"
                            className="msgimgch"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent click event
                              navigate("/ambassadoruserprofile");
                            }}
                          />
                          <div>
                            <div className="fs-5 mt-2 ftlink fw-bold">
                              {msg.name}
                            </div>
                            <small>{msg.message}</small>
                          </div>
                        </div>
                        <small className="mt-4 fw600 ">{msg.timeAgo}</small>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div>
              {/* Message Box (Chat Details) */}
              {selectedUser2 && (
                <div
                  className=" masboxmw d-lg-block d-none pb-1 rounded-1 w-100"
                  style={{
                    maxWidth: "855px",
                    // height: "590px",
                    height: "auto",
                    backgroundColor: "#D9D9D952",
                  }}
                >
                  <div className="d-flex justify-content-between mx-2">
                    <div className="d-flex gap-1 pt-3 px-4">
                      <div>
                        <img
                          src={require("./image/paulsmithf.png")}
                          width="47"
                          height="47"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click event
                            navigate("/ambassadoruserprofile");
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                      <div>
                        <div className="fw-bold fs-6 mt-1">
                          {messages[0].name}
                        </div>

                        <small
                          className="text-muted d-flex gap-1 "
                          style={{ fontSize: "12px" }}
                        >
                          <img
                            src={require("../pages/image/locchat.png")}
                            alt="loc"
                            width="12"
                            height="12"
                            className="mt-1"
                          />
                          London, UK
                        </small>
                      </div>
                    </div>

                    <div className="px-2" style={{ cursor: "pointer" }}>
                      <Dropdown>
                        <Dropdown.Toggle as="div">
                          <img
                            src={require("./image/dot3.png")}
                            alt="dot"
                            className="mt-4 pt-3 mx-sm-4 mx-2"
                            style={{ display: "inline-block" }}
                          />
                        </Dropdown.Toggle>
                        <div className="dropchat">
                          <Dropdown.Menu className="py-2 px-1  ">
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                              onClick={() => navigate("/ambassadoruserprofile")}
                            >
                              View Profile
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Mute
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Block
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Report
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </div>
                      </Dropdown>
                    </div>
                  </div>

                  <div
                    className=" w-100 mt-3 "
                    style={{
                      maxWidth: "854px ",
                      height: "1px",
                      border: "1px solid black",
                    }}
                  ></div>
                  <div className="mt-3">
                    {selectedUser2.details.map((detail, index) => (
                      <div
                        key={index}
                        className="d-flex gap-3 mb-3 px-4 mx-2 pt-3"
                      >
                        <div className="me-2">
                          <img
                            src={require("./image/paulsmithf.png")}
                            alt="profile"
                            className="rounded-circle"
                            width="41"
                            height="41"
                          />
                        </div>
                        <div
                          className="p-2 rounded-4 w-100"
                          style={{
                            backgroundColor: "#DEDEDE",
                            maxWidth: "772px",
                            height: "116px",
                          }}
                        >
                          <div className="d-flex justify-content-between">
                            <div
                              className="mb-0 w-100 fw-normal fs-16 px-3 py-1"
                              style={{ maxWidth: "722px" }}
                            >
                              {detail.text}
                            </div>
                            <small className=" mx-4 pt-5 mt-4 fw600">
                              {detail.time}
                            </small>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div
                      className="w-100 mt-5"
                      style={{
                        maxWidth: "855px",
                        height: "322px",
                        backgroundColor: "#D9D9D98F",
                      }}
                    >
                      <div
                        className="pt-5 px-5 fs-5   fw-bold w-100  text-center "
                        style={{ maxWidth: "774px" }}
                      >
                        Hi Rose, James P. would like to chat with you about the
                        Book Duo [NAME OF THE BOOK DUO]. Do you want to start
                        the conversation?
                      </div>

                      <div className="d-flex flex-wrap gap-4 justify-content-center mt-4">
                        <button
                          className="w-100 chat2wid border-0 text-white fw600 fs-5  rounded-1"
                          style={{
                            backgroundColor: "#62C0C7",
                            maxWidth: "143px ",
                            height: "44px",
                          }}
                          onClick={handleAccept}
                        >
                          Accept
                        </button>

                        <button
                          className="w-100 chat2wid border-0 text-white fw600 fs-5  rounded-1"
                          style={{
                            backgroundColor: "#62C0C7",
                            maxWidth: "143px ",
                            height: "44px",
                          }}
                          onClick={handleReject}
                        >
                          Reject
                        </button>
                      </div>
                      <div
                        className="d-flex bg-transparent mx-3 sendwidlg  w-100 mb-5 mt-4 rounded-1"
                        style={{
                          height: "40",
                          maxWidth: "740px ",
                          border: "1px solid #868686",
                          position: "relative",
                        }}
                      >
                        <div
                          className="w-100 my-1 mx-1 position-absolute"
                          style={{
                            backgroundColor: "unset",
                            maxWidth: "33px",
                            // height: "33px",
                            // right: "1px",

                            bottom: message ? "10px" : "50%", // Moves up when typing
                            transform: message
                              ? "translateY(5px)"
                              : "translateY(50%)",
                            // transition: "0.2s ease",
                          }}
                        >
                          <img
                            src={require("./image/chatemj.png")}
                            width="24"
                            height="24"
                            className="mx-2 mt-2"
                          />
                        </div>
                        <textarea
                          ref={textareaRef}
                          className="form-control bg-transparent border-0 fs-5 rounded-0 placeholder-login"
                          id="text"
                          value={message}
                          onChange={handleInputChange}
                          // placeholder="Type a message"
                          style={{
                            resize: "none",
                            overflow: "hidden",
                            height: "40px",
                            minHeight: "40px", // Fixed minimum height
                            maxHeight: "150px", // Expands up to 150px
                            flexGrow: 1,
                            paddingLeft: "50px",
                            paddingRight: "50px", // Ensure text doesn’t overlap with send icon
                          }}
                        />
                        {/* <input
                        type="text"
                        className="form-control border-0 fs-5 rounded-0 placeholder-login"
                        id="text"
                      /> */}
                        <div
                          className="w-100 my-1 mx-1 position-absolute"
                          style={{
                            backgroundColor: "#CDCDCD",
                            maxWidth: "33px",
                            height: "33px",
                            right: "1px",

                            bottom: message ? "0px" : "40%", // Moves up when typing
                            transform: message
                              ? "translateY(0)"
                              : "translateY(50%)",
                            transition: "0.2s ease",
                          }}
                        >
                          <img
                            src={require("./image/sendmsgicon.png")}
                            className="px-2 py-2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="">
              {isMobileDetailView && selectedUser2 && (
                <div
                  className=" masboxmw d-block d-lg-none bgnoneunset pb-1 rounded-1 w-100 "
                  style={{
                    maxWidth: "855px",
                    height: "auto",

                    backgroundColor: "#D9D9D952",
                  }}
                >
                  <div className="d-flex justify-content-between mx-2">
                    <div className="d-flex gap-sm-3 gap-1 pt-3 px-sm-3">
                      {/* Go Back Button */}
                      <div onClick={handleGoBack} className="back-arrow  my-2">
                        <ArrowLeft size={24} />{" "}
                        {/* This will render an arrow icon */}
                      </div>
                      {/* <button
                        onClick={handleGoBack}
                        className="btn btn-secondary mb-3"
                      >
                        Go Back
                      </button> */}
                      <div>
                        <img
                          src={require("./image/paulsmithf.png")}
                          width="47"
                          height="47"
                          className="detimgzch"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click event
                            navigate("/ambassadoruserprofile");
                          }}
                        />
                      </div>
                      <div>
                        <div className="fw-bold fontmobil fs-6 mt-md-1">
                          {messages[0].name}
                        </div>

                        <small
                          className="text-muted d-flex gap-1 "
                          style={{ fontSize: "12px" }}
                        >
                          <img
                            src={require("../pages/image/locchat.png")}
                            alt="loc"
                            width="12"
                            height="12"
                            className="mt-1"
                          />
                          London, UK
                        </small>
                      </div>
                    </div>

                    <div className="px-2" style={{ cursor: "pointer" }}>
                      <Dropdown>
                        <Dropdown.Toggle as="div">
                          <img
                            src={require("./image/dot3.png")}
                            alt="dot"
                            className="mt-4 pt-3 mx-sm-4 mx-2 widot"
                            style={{ display: "inline-block" }}
                          />
                        </Dropdown.Toggle>
                        <div className="  dropchatmob">
                          <Dropdown.Menu className="py-2 px-1">
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                              onClick={() => navigate("/ambassadoruserprofile")}
                            >
                              View Profile
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Mute
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Block
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Report
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </div>
                      </Dropdown>
                    </div>
                  </div>

                  <div
                    className=" w-100 mt-3 "
                    style={{
                      maxWidth: "854px ",
                      height: "1px",
                      border: "1px solid black",
                    }}
                  ></div>

                  {/* Message Box (Chat Details) - Show on Mobile when in Detail View */}
                  <div className="mt-3">
                    {selectedUser2.details.map((detail, index) => (
                      <div
                        key={index}
                        className="d-flex padsm gap-sm-3 gap-1 mb-3 px-sm-4 mx-sm-2 pt-3"
                      >
                        <div className="me-2 padsm">
                          <img
                            src={require("./image/paulsmithf.png")}
                            alt="profile"
                            className="rounded-circle"
                            width="41"
                            height="41"
                          />
                        </div>
                        <div
                          className="p-2 rounded-4 w-100"
                          style={{
                            backgroundColor: "#DEDEDE",
                            maxWidth: "772px",
                            height: "116px",
                          }}
                        >
                          <div className="d-flex justify-content-between">
                            <div
                              className="mb-0 w-100 fontmobil fw-normal fs-6 px-sm-3 py-sm-1"
                              style={{ maxWidth: "722px" }}
                            >
                              {detail.text}
                            </div>
                            <small className=" mx-sm-4 pt-5 mt-4 fw600">
                              {detail.time}
                            </small>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div
                      className="w-100 mt-5 pb-1"
                      style={{
                        maxWidth: "855px",
                        height: "auto",
                        backgroundColor: "#D9D9D98F",
                      }}
                    >
                      <div
                        className="pt-5 px-5 fs-5 ftzevtt fw-bold w-100  text-center "
                        style={{ maxWidth: "774px" }}
                      >
                        Hi Rose, James P. would like to chat with you about the
                        1:1 [NAME OF THE 1:1]. Do you want to start the
                        conversation?
                      </div>

                      <div className="d-flex flex-wrap gap-4 justify-content-center mt-4">
                        <button
                          className="w-100 chat2wid border-0 text-white fw600 fs-5  rounded-1"
                          style={{
                            backgroundColor: "#62C0C7",
                            maxWidth: "143px ",
                            height: "44px",
                          }}
                          onClick={handleAccept}
                        >
                          Accept
                        </button>

                        <button
                          className="w-100 border-0 chat2wid text-white fw600 fs-5  rounded-1"
                          style={{
                            backgroundColor: "#62C0C7",
                            maxWidth: "143px ",
                            height: "44px",
                          }}
                          onClick={handleReject}
                        >
                          Reject
                        </button>
                      </div>

                      <div
                        className="d-flex bg-transparent mx-sm-3 mx-auto sendwidmobli  w-100 mb-5 mt-4 rounded-1"
                        style={{
                          height: "40",
                          maxWidth: "660px ",
                          border: "1px solid #868686",
                          position: "relative",
                        }}
                      >
                        <div
                          className="w-100 my-1 mx-1 position-absolute"
                          style={{
                            backgroundColor: "unset",
                            maxWidth: "33px",
                            // height: "33px",
                            // right: "1px",

                            bottom: message ? "10px" : "50%", // Moves up when typing
                            transform: message
                              ? "translateY(5px)"
                              : "translateY(50%)",
                            // transition: "0.2s ease",
                          }}
                        >
                          <img
                            src={require("./image/chatemj.png")}
                            width="24"
                            height="24"
                            className="mx-2 mt-2"
                          />
                        </div>
                        <textarea
                          ref={textareaRef}
                          className="form-control bg-transparent  border-0 fs-5 rounded-0 placeholder-login"
                          id="text"
                          value={message}
                          onChange={handleInputChange}
                          // placeholder="Type a message"
                          style={{
                            resize: "none",
                            overflow: "hidden",
                            height: "40px",
                            minHeight: "40px", // Fixed minimum height
                            maxHeight: "150px", // Expands up to 150px
                            flexGrow: 1,
                            paddingLeft: "50px",
                            paddingRight: "45px", // Ensure text doesn’t overlap with send icon
                          }}
                        />

                        {/* <input
                        type="text"
                        className="form-control border-0 fs-5 rounded-0 placeholder-login"
                        id="text"
                      /> */}
                        <div
                          className="w-100 my-1 mx-1 position-absolute"
                          style={{
                            backgroundColor: "#CDCDCD",
                            maxWidth: "33px",
                            height: "33px",
                            right: "1px",

                            bottom: message ? "0px" : "40%", // Moves up when typing
                            transform: message
                              ? "translateY(0)"
                              : "translateY(50%)",
                            transition: "0.2s ease",
                          }}
                        >
                          <img
                            src={require("./image/sendmsgicon.png")}
                            className="px-2 py-2"
                          />
                        </div>
                      </div>
                      <div
                        className="d-flefffx d-none bg-transparent mx-sm-3 mx-auto sendwidmobli  w-100 mb-5 mt-4 rounded-1"
                        style={{
                          height: "40",
                          maxWidth: "660px ",
                          border: "1px solid #868686",
                        }}
                      >
                        <img
                          src={require("./image/chatemj.png")}
                          width="24"
                          height="24"
                          className="mx-2 mt-2"
                        />

                        <input
                          type="text"
                          className="form-control bg-transparent border-0 fs-5 rounded-0 placeholder-login"
                          id="text"
                        />
                        <div
                          className="w-100 my-1 mx-1"
                          style={{
                            backgroundColor: "#CDCDCD",
                            maxWidth: "33px",
                            height: "33px",
                          }}
                        >
                          <img
                            src={require("./image/sendmsgicon.png")}
                            className="px-2 py-2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatBox2;
